import { render, staticRenderFns } from "./WeddingEventImageCommentForm.vue?vue&type=template&id=1c88d664"
import script from "./WeddingEventImageCommentForm.vue?vue&type=script&lang=ts"
export * from "./WeddingEventImageCommentForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports